import React, { useContext } from "react";
import ReactDOM from "react-dom";
import ProductOptionStep from "./ProductOptionStep";
import ProductOptionRefProvider from "../../Providers/ProductOptionRefProvider";
import ProductOptionStepsProvider, {
    ProductOptionStepsContext
} from "../../Providers/ProductOptionStepsProvider";
import Loader from "../../UX/Loader/Loader";
import Modal from "../../UX/Modal/Modal";
import Overlay from "../../UX/Overlay/Overlay";
import FileUploadProvider from "../../Providers/FileUploadProvider/FileUploadProvider";
import TranslationProvider from "../../Providers/TranslationProvider";
import FileUploadModal from "./Steps/FileUpload/FileUploadModal";
import ExtraProductOptionInfo from "./ExtraProductOptionInfo";
import { ReusableProvider } from "reusable";
import VerspreidenProvider from "../../Providers/VerspreidenProvider";


const ProductOptions = props => {
    //const isIE = /*@cc_on!@*/ false || !!document.documentMode;
    const {
        steps,
        loading,
        modal,
        onCloseModal,
        submittingCart,
        error
    } = useContext(ProductOptionStepsContext);
    if (error) {
        return (
            <div className="flex flex-col justify-center items-center w-full">
                <h3>{error.message}</h3>
            </div>
        );
    }

    if (loading) {
        return (
            <div className="flex flex-col justify-center items-center w-full">
                <Loader />
                <h3>Productopties aan het laden</h3>
            </div>
        );
    } else {
        return (
            <>
                <ExtraProductOptionInfo />
                <Modal
                    // size="medium"
                    onClose={onCloseModal}
                    display={modal.show}
                    loading={modal.loading}
                    loadText={"Informatie aan het ophalen"}
                >
                    <div dangerouslySetInnerHTML={{ __html: modal.content }} />
                </Modal>
                <Overlay
                    show={submittingCart.loading}
                    message={"Producten toevoegen aan winkelwagen"}
                />

                <FileUploadModal />
                <div id="product-options" className="">
                    {steps.map(step => (
                        <ProductOptionStep key={step.id} step={step} />
                    ))}
                </div>
            </>
        );
    }
};

export default ProductOptions;

if (document.getElementById("productoptions")) {
    const element = document.getElementById("productoptions");

    ReactDOM.render(
        <ReusableProvider>
            <ProductOptionRefProvider>
                <TranslationProvider translations={element.dataset.lang}>
                    <FileUploadProvider
                        uploadSetting={element.dataset.uploadSetting}
                    >
                        <VerspreidenProvider>
                            <ProductOptionStepsProvider {...element.dataset}>
                                <ProductOptions />
                            </ProductOptionStepsProvider>
                        </VerspreidenProvider>
                    </FileUploadProvider>
                </TranslationProvider>
            </ProductOptionRefProvider>
        </ReusableProvider>,
        document.getElementById("productoptions")
    );
}
